import { InjectionToken } from "@angular/core";
import type { FilterRegistration } from "./filter.types";
import { FilterViewTypeEnum } from "./filter.types";

export const VIEW_TYPE = new InjectionToken<FilterViewTypeEnum>("VIEW_TYPE", {
    factory: () => FilterViewTypeEnum.Normal,
});

export const FILTER_REGISTRY = new InjectionToken<FilterRegistration[]>("FILTER_REGISTRY");
